(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[719],{

/***/ "5Rjz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "NavigationLargeSubNav", function() { return /* binding */ NavigationLargeSubNav_NavigationLargeSubNav; });

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/lodash.js
var lodash = __webpack_require__("nsO7");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./src/client/components/widgets/navigation/Navigation.constants.js
var Navigation_constants = __webpack_require__("1cDg");

// EXTERNAL MODULE: ./src/client/components/utils/ratios/ratios.utils.js
var ratios_utils = __webpack_require__("u/u4");

// EXTERNAL MODULE: ./src/client/components/frameworks/dynamic-link/DynamicLink.jsx
var DynamicLink = __webpack_require__("i5Mr");

// EXTERNAL MODULE: ./src/client/components/frameworks/text-link/TextLink.jsx + 1 modules
var TextLink = __webpack_require__("jD8k");

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/frameworks/image/Image.jsx + 1 modules
var Image = __webpack_require__("0IQ5");

// EXTERNAL MODULE: ./src/client/tracking/track-click/TrackClick.jsx
var TrackClick = __webpack_require__("NJJ8");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// CONCATENATED MODULE: ./src/client/components/frameworks/thumbnail-navigation/ThumbnailNavigation.themes.js


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}


var themes = {
  "default": function _default(_ref) {
    var hasImageBorder = _ref.hasImageBorder,
        hasLink = _ref.hasLink,
        isHovering = _ref.isHovering;
    return {
      thRoot: '',
      thLink: classnames_default()('bg-black block overflow-hidden relative', {
        'decoration-fancy-frame': hasImageBorder
      }),
      thThumbnail: classnames_default()({
        'transition-transform-opacity': hasLink,
        'opacity-50 scale-105 ': hasLink && isHovering
      }),
      thLabel: classnames_default()('absolute px-px5 text-center text-md text-shadow-1 text-white -translate-y-50 w-full', {
        'top-1/2': !isHovering,
        'top-9/20': isHovering
      }),
      thLabelStyle: _objectSpread({}, isHovering ? {
        top: '45%',
        transition: 'all ease-in 0.25s'
      } : {
        top: '50%',
        transition: 'all ease-in 0.25s 0.15s'
      }),
      thSeeMoreLabel: 'absolute flex items-center justify-center leading-one text-center text-shadow-1 text-white uppercase w-full',
      thSeeMoreLabelStyle: _objectSpread({
        fontSize: '0.6875rem'
      }, isHovering ? {
        bottom: '30%',
        opacity: 1,
        transition: 'all ease-in 0.15s 0.2s'
      } : {
        bottom: '27%',
        opacity: 0,
        transition: 'all ease-in 0.15s'
      }),
      thSeeMoreIcon: 'mx-px5',
      thSeeMoreIconSize: '0.625rem',
      thBody: 'p-px10'
    };
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/thumbnail-navigation/ThumbnailNavigation.jsx

var __jsx = react_default.a.createElement;









var ThumbnailNavigation_ThumbnailNavigation = function ThumbnailNavigation(_ref) {
  var children = _ref.children,
      className = _ref.className,
      hasImageBorder = _ref.hasImageBorder,
      label = _ref.label,
      link = _ref.link,
      seeMoreLabel = _ref.seeMoreLabel,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme,
      thumbnail = _ref.thumbnail;

  var _useState = Object(react["useState"])(false),
      isHovering = _useState[0],
      setHovering = _useState[1];

  if (!thumbnail.imageUrl) {
    return null;
  }

  var hasLink = link === null || link === void 0 ? void 0 : link.url;

  var _themes$theme = themes[theme]({
    hasImageBorder: hasImageBorder,
    hasLink: hasLink,
    isHovering: isHovering
  }),
      thBody = _themes$theme.thBody,
      thLabel = _themes$theme.thLabel,
      thLabelStyle = _themes$theme.thLabelStyle,
      thLink = _themes$theme.thLink,
      thRoot = _themes$theme.thRoot,
      thSeeMoreIcon = _themes$theme.thSeeMoreIcon,
      thSeeMoreIconSize = _themes$theme.thSeeMoreIconSize,
      thSeeMoreLabel = _themes$theme.thSeeMoreLabel,
      thSeeMoreLabelStyle = _themes$theme.thSeeMoreLabelStyle,
      thThumbnail = _themes$theme.thThumbnail;

  var onEnter = hasLink ? function () {
    return setHovering(true);
  } : null;
  var onLeave = hasLink ? function () {
    return setHovering(false);
  } : null;
  return __jsx("div", {
    className: classnames_default()(className, thRoot, 'h-full')
  }, __jsx(TrackClick["a" /* TrackClick */], Object(esm_extends["a" /* default */])({}, link, {
    as: hasLink ? DynamicLink["a" /* default */] : 'div',
    className: thLink,
    onMouseEnter: onEnter,
    onMouseLeave: onLeave,
    onFocus: onEnter,
    onBlur: onLeave
  }), __jsx(Image["b" /* default */], Object(esm_extends["a" /* default */])({}, thumbnail, {
    className: thThumbnail,
    ratioKey: thumbnail.ratioKey || ratios_utils["a" /* default */].XL,
    ratioDisplay: 1 / 4
  })), !!label && __jsx("div", {
    className: thLabel,
    style: thLabelStyle
  }, label), !!seeMoreLabel && __jsx("div", {
    className: thSeeMoreLabel,
    style: thSeeMoreLabelStyle
  }, seeMoreLabel, __jsx(Icon["a" /* Icon */], {
    className: thSeeMoreIcon,
    hasRtl: true,
    name: icons["a" /* ICONS */].BOLDER_ARROW_FORTH,
    width: thSeeMoreIconSize
  }))), !!children && !!react["Children"].count(children) && __jsx("div", {
    className: thBody
  }, children));
};
// CONCATENATED MODULE: ./src/client/components/widgets/navigation/large/subnavs/NavigationLargeSubNav.jsx

var NavigationLargeSubNav_jsx = react_default.a.createElement;









var NavigationLargeSubNav_NavigationLargeSubNav = function NavigationLargeSubNav(_ref) {
  var _ref$subItems = _ref.subItems,
      subItems = _ref$subItems === void 0 ? [] : _ref$subItems;

  if (Object(lodash["isEmpty"])(subItems)) {
    return null;
  }

  return NavigationLargeSubNav_jsx("div", {
    className: "bg-white overflow-y-auto px-px50 py-px25",
    style: {
      maxHeight: Navigation_constants["a" /* NAVIGATIONLARGE_SUBNAV_MAX_HEIGHT */]
    }
  }, NavigationLargeSubNav_jsx("ul", {
    className: "flex flex-wrap -m-px10 reset-list"
  }, subItems.map(function (item) {
    var _item$thumbnail;

    var thumbnail = {
      imageUrl: ((_item$thumbnail = item.thumbnail) === null || _item$thumbnail === void 0 ? void 0 : _item$thumbnail.imageUrl) || '',
      ratioKey: !Object(lodash["isEmpty"])(item.subItems) ? ratios_utils["a" /* default */].S : ratios_utils["a" /* default */].XL
    };
    return NavigationLargeSubNav_jsx("li", {
      className: "p-px10 w-1/4",
      key: item.label
    }, NavigationLargeSubNav_jsx(ThumbnailNavigation_ThumbnailNavigation, {
      hasImageBorder: item.hasImageBorder,
      label: item.label,
      link: Object(lodash["isEmpty"])(item.subItems) ? item.link : null,
      seeMoreLabel: item.seeMoreLabel,
      thumbnail: thumbnail
    }, !Object(lodash["isEmpty"])(item.subItems) && NavigationLargeSubNav_jsx(react["Fragment"], null, NavigationLargeSubNav_jsx("ul", {
      className: "font-bold font-sans reset-list text-gray-darker text-sm"
    }, (item.subItems || []).map(function (subitem) {
      return subitem.label ? NavigationLargeSubNav_jsx("li", {
        key: subitem.label
      }, NavigationLargeSubNav_jsx(TrackClick["a" /* TrackClick */], Object(esm_extends["a" /* default */])({}, subitem.link, {
        as: DynamicLink["a" /* default */],
        className: "inline-block no-underline py-px5 text-gray-darker focus:text-blue hover:text-blue transition-color",
        "data-testid": "NavigationLargeSubNav-third-link"
      }), subitem.label)) : null;
    })), item.seeMoreLabel && NavigationLargeSubNav_jsx(TextLink["a" /* TextLink */], Object(esm_extends["a" /* default */])({}, item.link, {
      className: "mt-px10 uppercase",
      color: colors["a" /* COLORS */].GRAY_MEDIUM,
      label: item.seeMoreLabel,
      theme: "fancy",
      trackingData: item.link.trackingData
    })))));
  })));
};

/***/ })

}]);